import './ZoneSlot.css';
//import '../pages/DuelPage.css';
import React, { useRef, useEffect } from 'react';
import { playSound } from '../utils/soundPlayer';
import { doc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { syncGameState } from '../logic/DuelLogic';

const PvpSlot  = ({
  label,
  fieldMap,
  setFieldMap,
  pendingSummon,
  setPendingSummon,
  pendingNormalSummon,
  setPendingNormalSummon,
  syncGameState,
  opponentGY,
  opponentBZ,
  opponentFieldMap,

  summonPosition,          // ✅ this is fine
  setHand,
  myGYZ,
  myBZ,
  setViewZoneCards,
  setZoneViewerTitle,
  setShowDeckMenu,
  setShowExtraMenu,
  mainDeck,
  pendingSTPlacement,
  pendingFieldPlacement,
  setPendingFieldPlacement,
  extraDeck,
  setMyGYZ,
  setPendingSTPlacement,
  pendingExtraSummon,
  setPendingExtraSummon,
  setSelectedCard,
  pendingFieldMove,
  setPendingFieldMove,
  setExtraDeck, // ✅ add this line
  setMyBZ, // ✅ add this
  setMainDeck, // ✅ ADD THIS
  pendingOverlay,
  setPendingOverlay,
  pendingSSATKHand,
  setPendingSSATKHand,
  pendingSSDEFHand,
  setPendingSSDEFHand,
  pendingSetMonsterHand,
  setPendingSetMonsterHand,
  pendingToken,
  setPendingToken,
  extraSummonPosition,
  roomId,
  playerRole,
  opponentMainDeck,
  opponentExtraDeck,
  hand,
 
  
  db
 }) => {

  const isOpponent = label.startsWith('Opp');
  const zoneData = fieldMap[label]; // always use the passed map
  const isEmpty = !zoneData?.card;


  const card = zoneData?.card;
  const isFaceDown = card?.isFaceDown;


    // 🔒 Opponent zone: just display their card (read-only)
//     if (label.startsWith('Opp') && zoneData?.card) {
//   return (
//     <div className="card-wrapper-zone">
//       <img
//         onContextMenu={(e) => e.preventDefault()}
//         onMouseDown={(e) => e.button === 2 && e.preventDefault()}
//         onTouchStart={(e) => e.preventDefault()}
//         draggable={false}
//         src={
//           zoneData.card.isFaceDown
//             ? require('../assets/images/card-back.jpg')
//             : zoneData.card.card_images?.[0]?.image_url
//         }
//         alt={zoneData.card.name}
//         className={`zone-card-image ${
//           zoneData.position === 'DEF' ? 'defense' : ''
//         }`}
//       />
//       {zoneData.overlays?.length > 0 && (
//         <div className="zone-count">×{zoneData.overlays.length}</div>
//       )}
//     </div>
//   );
// }

    

    const syncFieldMap = async (updatedFieldMap) => {
    if (!roomId || !playerRole) return;
    const roomRef = doc(db, 'duelRooms', roomId);

    try {
        await updateDoc(roomRef, {
        [`gameState.${playerRole}.fieldMap`]: updatedFieldMap,
        [`gameState.updatedAt`]: serverTimestamp(),
        });
    } catch (err) {
        // Removed: console.error('🔥 Failed to sync fieldMap from ZoneSlot:', err);
    }
    };

  const handleZoneClick = () => {
    const isMZ = label.startsWith('My MZ');
    const isEmpty = !fieldMap[label];

  if (pendingToken && label.startsWith('My MZ') && !fieldMap[label]) {
    const tokenCard = {
      id: 'token-' + Date.now(),
      name: 'Token',
      type: 'Monster Token',
      atk: 0,
      def: 0,
      level: 1,
      race: 'Token',
      attribute: 'DARK',
      desc: 'This is a Token.',
      card_images: [{ image_url: '/token.png' }]
    };

    const updatedFieldMap = {
      ...fieldMap,
      [label]: {
        card: tokenCard,
        position: 'ATK',
        from: 'token'
      }
    };

    setFieldMap(updatedFieldMap);
    setPendingToken(false);

    // ✅ Sync to Firestore
    syncGameState({
      fieldMap: updatedFieldMap,
      hand,
      mainDeck,
      extraDeck,
      gy: myGYZ,
      bz: myBZ,
      roomId,
      playerRole
    });

    return;
  }



if (pendingSSATKHand && label.startsWith('My MZ') && isEmpty) {
    playSound('ss');

    const updatedFieldMap = {
      ...fieldMap,
      [label]: {
        card: pendingSSATKHand,
        position: 'ATK',
        from: 'hand'
      }
    };

    const updatedHand = [...hand];
    const index = updatedHand.findIndex(
      c => c === pendingSSATKHand || c === pendingSSATKHand.original
    );
    if (index !== -1) {
      updatedHand.splice(index, 1);
    }

    setFieldMap(updatedFieldMap);
    setHand(updatedHand);
    setPendingSSATKHand(null);
    syncGameState({
      fieldMap: updatedFieldMap,
      hand: updatedHand,
      mainDeck: mainDeck || [],
      extraDeck,
      gy: myGYZ,
      bz: myBZ,
      roomId,
      playerRole
    });

    return;
  }


if (pendingSSDEFHand && label.startsWith('My MZ') && !fieldMap[label]) {
  playSound('ss');

  const updatedFieldMap = {
    ...fieldMap,
    [label]: {
      card: pendingSSDEFHand,
      position: 'DEF',
      from: 'hand'
    }
  };

  const updatedHand = [...hand];
    const index = updatedHand.findIndex(c => c === pendingSSDEFHand || c === pendingSSDEFHand.original);
    if (index !== -1) {
    updatedHand.splice(index, 1);
    }
    setHand(updatedHand);

  // ✅ Update local state first
  setFieldMap(updatedFieldMap);
  setHand(updatedHand);
  setPendingSSDEFHand(null);

  // ✅ Then sync full state to Firestore
  syncGameState({
    fieldMap: updatedFieldMap,
    hand: updatedHand,
    mainDeck,
    extraDeck,
    gy: myGYZ,
    bz: myBZ,
    roomId,
    playerRole
  });

  return;
}


if (pendingSetMonsterHand && label.startsWith('My MZ') && !fieldMap[label]) {
  playSound('set');

  const updatedFieldMap = {
    ...fieldMap,
    [label]: {
      card: pendingSetMonsterHand,
      position: 'DEF',
      from: 'hand',
      isFaceDown: true
    }
  };


    const updatedHand = [...hand];
        const index = updatedHand.findIndex(c => c === pendingSetMonsterHand || c === pendingSetMonsterHand.original);
        if (index !== -1) {
        updatedHand.splice(index, 1);
        }
    setHand(updatedHand);

  // ✅ Update local state
  setFieldMap(updatedFieldMap);
  setHand(updatedHand);
  setPendingSetMonsterHand(null);

  // ✅ Sync to Firestore
  syncGameState({
    fieldMap: updatedFieldMap,
    hand: updatedHand,
    mainDeck,
    extraDeck,
    gy: myGYZ,
    bz: myBZ,
    roomId,
    playerRole
  });

  return;
}

if (pendingOverlay && label.startsWith('My MZ')) {
  const clickedCard = fieldMap[label]?.card;

  // ✅ 1. If the clicked zone has no card, do nothing
  if (!clickedCard) return;

  // ✅ 2. If it's the same card that triggered the overlay, cancel
  if (clickedCard.id === pendingOverlay.id) {
    setPendingOverlay(null);
    return;
  }

  // ✅ 3. Prepare new updatedFieldMap
  const newMap = { ...fieldMap };
  const target = newMap[label] || {};
  const overlays = target.overlays ? [...target.overlays, pendingOverlay] : [pendingOverlay];

  newMap[label] = {
    ...target,
    overlays
  };

  if (pendingOverlay.zone && newMap[pendingOverlay.zone]) {
    delete newMap[pendingOverlay.zone];
  }

  // ✅ Local update
  setFieldMap(newMap);
  setPendingOverlay(null);

  // ✅ Sync full game state
  syncGameState({
    fieldMap: newMap,
    hand,
    mainDeck,
    extraDeck,
    gy: myGYZ,
    bz: myBZ,
    roomId,
    playerRole
  });

  return;
}

if (pendingExtraSummon && (label.startsWith('My MZ') || label.includes('EXMZ'))) {
  const zoneOccupied = !!fieldMap[label];
  playSound('ss');

  // 🧩 Normal Extra Summon into empty zone
  if (!zoneOccupied && !pendingExtraSummon.xyzMode) {
    

    const updatedFieldMap = {
      ...fieldMap,
      [label]: {
        card: { ...pendingExtraSummon },
        position: extraSummonPosition,
        from: 'extra',
        overlays: []
      }
    };

    const updatedExtraDeck = [...extraDeck];
    const index = updatedExtraDeck.findIndex(c => c.id === pendingExtraSummon.id);
    if (index !== -1) updatedExtraDeck.splice(index, 1);

    setFieldMap(updatedFieldMap);
    setExtraDeck(updatedExtraDeck);
    setPendingExtraSummon(null);

    syncGameState({
      fieldMap: updatedFieldMap,
      hand,
      mainDeck,
      extraDeck: updatedExtraDeck,
      gy: myGYZ,
      bz: myBZ,
      roomId,
      playerRole
    });

    return;
  }

  // 🔷 Xyz Summon over existing monster
  if (zoneOccupied && pendingExtraSummon.xyzMode) {
    playSound('xyz');

    const existingCard = fieldMap[label].card;
    const existingOverlays = fieldMap[label].overlays || [];

    const combinedOverlays = [...existingOverlays, existingCard];

    const updatedFieldMap = {
      ...fieldMap,
      [label]: {
        card: { ...pendingExtraSummon },
        position: extraSummonPosition,
        from: 'extra',
        overlays: combinedOverlays
      }
    };

    const updatedExtraDeck = [...extraDeck];
    const index = updatedExtraDeck.findIndex(c => c.id === pendingExtraSummon.id);
    if (index !== -1) updatedExtraDeck.splice(index, 1);

    setFieldMap(updatedFieldMap);
    setExtraDeck(updatedExtraDeck);
    setPendingExtraSummon(null);

    syncGameState({
      fieldMap: updatedFieldMap,
      hand,
      mainDeck,
      extraDeck: updatedExtraDeck,
      gy: myGYZ,
      bz: myBZ,
      roomId,
      playerRole
    });

    return;
  }
}


if (pendingSummon && label.startsWith('My MZ') && !fieldMap[label]) {
  playSound('ss');

  // ✅ Build new field map
  const updatedFieldMap = {
    ...fieldMap,
    [label]: {
      card: pendingSummon,
      position: summonPosition,
      from: 'hand'
    }
  };

  // ✅ Clean up origin zone
  let updatedHand = [...hand];
  let updatedMainDeck = [...mainDeck];
  let updatedGY = [...myGYZ];
  let updatedBZ = [...myBZ];

  if (pendingSummon.origin === 'GY') {
    updatedGY = updatedGY.filter(c => c !== pendingSummon.original);
  } else if (pendingSummon.origin === 'BZ') {
    updatedBZ = updatedBZ.filter(c => c !== pendingSummon.original);
  } else if (pendingSummon.origin === 'Deck') {
    const index = updatedMainDeck.findIndex(c => c.id === pendingSummon.original.id);
    if (index !== -1) updatedMainDeck.splice(index, 1);
  } else {
    // From hand
    const updatedHand = [...hand];
    const index = updatedHand.findIndex(c => c === pendingSummon || c === pendingSummon.original);
    if (index !== -1) {
    updatedHand.splice(index, 1);
    }
  }

  // ✅ Update UI state
  setFieldMap(updatedFieldMap);
  setHand(updatedHand);
  setMainDeck(updatedMainDeck);
  setMyGYZ(updatedGY);
  setMyBZ(updatedBZ);
  setPendingSummon(null);

  // ✅ Sync all changes
  syncGameState({
    fieldMap: updatedFieldMap,
    hand: updatedHand,
    mainDeck: updatedMainDeck,
    extraDeck,
    gy: updatedGY,
    bz: updatedBZ,
    roomId,
    playerRole
  });

  return;
}

if (pendingNormalSummon && label.startsWith('My MZ') && !fieldMap[label]) {
  playSound('ns');

  // ✅ Build new field map
  const updatedFieldMap = {
    ...fieldMap,
    [label]: {
      card: pendingNormalSummon,
      position: 'ATK',
      from: 'hand',
      normal: true
    }
  };


  const updatedHand = [...hand];
    const index = updatedHand.findIndex(c => c === pendingNormalSummon || c === pendingNormalSummon.original);
    if (index !== -1) {
    updatedHand.splice(index, 1);
    }
    setHand(updatedHand);
  

  // ✅ Update UI state
  setFieldMap(updatedFieldMap);
  setHand(updatedHand);
  setPendingNormalSummon(null);

  // ✅ Sync all changes
  syncGameState({
    fieldMap: updatedFieldMap,
    hand: updatedHand,
    mainDeck,
    extraDeck,
    gy: myGYZ,
    bz: myBZ,
    roomId,
    playerRole
  });

  return;
}

if (pendingSTPlacement && label.startsWith('My STZ') && !fieldMap[label]) {
  playSound('act');

  // ✅ Prepare updated field map
  const updatedFieldMap = {
    ...fieldMap,
    [label]: {
      card: pendingSTPlacement,
      position: 'FACEUP',
      from: 'hand',
      type: 'S/T'
    }
  };

  // ✅ Remove card from source
  let updatedHand = [...hand];
  let updatedGY = [...myGYZ];
  let updatedBZ = [...myBZ];
  let updatedDeck = [...mainDeck];

  if (pendingSTPlacement.origin === 'GY') {
    updatedGY = myGYZ.filter(c => c !== pendingSTPlacement.original);
  } else if (pendingSTPlacement.origin === 'BZ') {
    updatedBZ = myBZ.filter(c => c !== pendingSTPlacement.original);
  } else if (pendingSTPlacement.origin === 'Deck') {
    const index = updatedDeck.findIndex(c => c.id === pendingSTPlacement.original.id);
    if (index !== -1) updatedDeck.splice(index, 1);
  } else {
      const index = hand.findIndex(
        c => c === pendingSTPlacement || c === pendingSTPlacement.original
      );
      if (index !== -1) {
        updatedHand.splice(index, 1);
      }
    }

  // ✅ Apply locally
  setFieldMap(updatedFieldMap);
  setHand(updatedHand);
  setMyGYZ(updatedGY);
  setMyBZ(updatedBZ);
  setMainDeck(updatedDeck);
  setPendingSTPlacement(null);

  // ✅ Sync to Firestore
  syncGameState({
    fieldMap: updatedFieldMap,
    hand: updatedHand,
    mainDeck: updatedDeck,
    extraDeck,
    gy: updatedGY,
    bz: updatedBZ,
    roomId,
    playerRole
  });

  return;
}



if (pendingFieldPlacement && label === 'My FZ') {
  playSound('act');

  // 🔁 Track previous field card
  const previousFieldCard = fieldMap[label]?.card || null;

  // ✅ Build updated field map
  const updatedFieldMap = {
    ...fieldMap,
    [label]: {
      card: pendingFieldPlacement,
      position: 'FACEUP',
      from: 'hand',
      type: 'FIELD'
    }
  };

  // ✅ Remove previous field card to GY if any
  const updatedGY = previousFieldCard
    ? [...myGYZ, previousFieldCard]
    : [...myGYZ];


    const updatedHand = [...hand];
        const index = updatedHand.findIndex(c => c === pendingFieldPlacement || c === pendingFieldPlacement.original);
        if (index !== -1) {
        updatedHand.splice(index, 1);
        }
        setHand(updatedHand);



  // ✅ Apply all locally
  setFieldMap(updatedFieldMap);
  setHand(updatedHand);
  setMyGYZ(updatedGY);
  setPendingFieldPlacement(null);

  // ✅ Sync to Firestore
  syncGameState({
    fieldMap: updatedFieldMap,
    hand: updatedHand,
    mainDeck,
    extraDeck,
    gy: updatedGY,
    bz: myBZ,
    roomId,
    playerRole
  });

  return;
}


if (pendingFieldMove && !fieldMap[label]) {
  const fromZone = pendingFieldMove.zone;

  // ✅ Build updated field map
  const updatedFieldMap = { ...fieldMap };

  // ✅ Preserve overlays if present
  const overlays = fieldMap[fromZone]?.overlays || [];

  // ✅ Remove from old zone
  delete updatedFieldMap[fromZone];

  // ✅ Assign to new zone
  updatedFieldMap[label] = {
    card: pendingFieldMove,
    position: pendingFieldMove.position,
    from: 'field',
    overlays
  };

  // ✅ Local update
  setFieldMap(updatedFieldMap);
  setPendingFieldMove(null);

  // ✅ Sync full state
  syncGameState({
    fieldMap: updatedFieldMap,
    hand,
    mainDeck,
    extraDeck,
    gy: myGYZ,
    bz: myBZ,
    roomId,
    playerRole
  });

  return;
}

};

  return (
    <div
      className={`zone zone-${label.replace(/\s+/g, '-')}
        ${label === '' ? 'empty' : ''} 
        ${label.startsWith('My MZ') ? 'zone-clickable' : ''} 
        ${(pendingSummon || pendingNormalSummon || pendingSSATKHand || pendingSSDEFHand || pendingExtraSummon || pendingSetMonsterHand) && label.startsWith('My MZ') && !fieldMap[label] ? 'glow' : ''}
        ${pendingSTPlacement && label.startsWith('My STZ') && !fieldMap[label] ? 'glow' : ''}
        ${pendingFieldPlacement && label === 'My FZ' ? 'glow' : ''}
        ${pendingExtraSummon && label.includes('EXMZ') && !fieldMap[label] ? 'glow' : ''}
      `}
        onClick={handleZoneClick}
    >
      {label === 'My Deck' ? (
        <div
            className="deck-zone-wrapper"
            onClick={(e) => {
            e.stopPropagation();
            if (mainDeck.length > 0) {
                setShowDeckMenu(prev => !prev); // ✅ toggle options (Mill, Draw, etc.)
            }
            }}
            style={{ cursor: mainDeck.length > 0 ? 'pointer' : 'default', opacity: mainDeck.length > 0 ? 1 : 0.4 }}
        >
            {mainDeck.length > 0 && (
            <img
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
            draggable={false}
                src={require('../assets/images/card-back.jpg')}
                alt="Deck"
                className="deck-card-back"
            />
            )}
            <span className="deck-count">{mainDeck.length}</span>
        </div>
        ) :  label === 'My Extra' ? (
            <div
                className="deck-zone-wrapper"
                onClick={(e) => {
                e.stopPropagation();
                if (extraDeck.length > 0) {
                    setShowExtraMenu(prev => !prev);
                }
                }}
                style={{ cursor: extraDeck.length > 0 ? 'pointer' : 'default', opacity: extraDeck.length > 0 ? 1 : 0.4 }}
            >
                {extraDeck.length > 0 && (
                <img
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
            draggable={false}
                    src={require('../assets/images/card-back.jpg')}
                    alt="Extra Deck"
                    className="deck-card-back"
                />
                )}
                <span className="deck-count">{extraDeck.length}</span>
            </div>
        ) : label === 'My GYZ' && myGYZ.length > 0 ? (
        // continue with rest...

        <div
          className="zone-clickable"
          onClick={() => {
            setViewZoneCards(myGYZ);
            setZoneViewerTitle('Graveyard');
          }}
        >
          <img
          onContextMenu={(e) => e.preventDefault()}
          onMouseDown={(e) => e.button === 2 && e.preventDefault()}
          onTouchStart={(e) => e.preventDefault()}
          draggable={false}
            src={myGYZ[myGYZ.length - 1].card_images[0].image_url}
            alt="GY Top"
            className="zone-card-image"
          />
          <span className="zone-count">{myGYZ.length}</span>
        </div>
      ) : label === 'My BZ' && myBZ.length > 0 ? (
        <div
          className="zone-clickable"
          onClick={() => {
            setViewZoneCards(myBZ);
            setZoneViewerTitle('Banished');
          }}
        >
        <img
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
            draggable={false}
            src={
                myBZ[myBZ.length - 1].isFaceDown
                ? require('../assets/images/card-back.jpg')
                : myBZ[myBZ.length - 1].card_images[0].image_url
            }
            alt="BZ Top"
            className="zone-card-image"
        />
          <span className="zone-count">{myBZ.length}</span>
        </div>
        ) : // OPPONENT DECK
          label === 'Opp Deck'?(
            <div className="deck-zone-wrapper">
            <img
              src={require('../assets/images/card-back.jpg')}
              alt="Opponent Deck"
              className="deck-card-back"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
            />
            <span className="deck-count">{opponentMainDeck.length}</span>
          </div>

      // OPPONENT EXTRA
      ) : label === 'Opp Extra'? (
          <div className="deck-zone-wrapper">
            <img
              src={require('../assets/images/card-back.jpg')}
              alt="Opponent Extra Deck"
              className="deck-card-back"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
            />
            <span className="deck-count">{opponentExtraDeck.length}</span>
          </div>

      // OPPONENT GY
      ) : label === 'Opp GYZ' && opponentGY.length > 0 ? (
        <div
          className="zone-clickable"
          onClick={() => {
            setViewZoneCards(opponentGY);
            setZoneViewerTitle("Opponent GY");
          }}
        >
          <img
            src={
              opponentGY[opponentGY.length - 1].isFaceDown
                ? require('../assets/images/card-back.jpg')
                : opponentGY[opponentGY.length - 1].card_images?.[0]?.image_url
            }
            alt="Opponent GY"
            className="zone-card-image flipped-card"
            draggable={false}
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
          />
          <span className="zone-count">{opponentGY.length}</span>
        </div>


      // OPPONENT BZ
        ) : label === 'Opp BZ' && opponentBZ.length > 0 ? (
          <div
            className="zone-clickable"
            onClick={() => {
              setViewZoneCards(opponentBZ);
              setZoneViewerTitle("Opponent BZ");
            }}
          >
            <img
              src={
                opponentBZ[opponentBZ.length - 1].isFaceDown
                  ? require('../assets/images/card-back.jpg')
                  : opponentBZ[opponentBZ.length - 1].card_images?.[0]?.image_url
              }
              alt="Opponent BZ"
              className="zone-card-image flipped-card"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              onMouseDown={(e) => e.button === 2 && e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
            />
            <span className="zone-count">{opponentBZ.length}</span>
          </div>

        // ✅ INSERT THIS HERE — opponent field zones like MZ, STZ, FZ
        ) : opponentFieldMap[label]?.card ? (
          <div className="card-wrapper-zone">
            <img
  src={
    opponentFieldMap[label].card.isFaceDown
      ? require('../assets/images/card-back.jpg')
      : opponentFieldMap[label].card.card_images?.[0]?.image_url
  }
  alt={opponentFieldMap[label].card.name}
  className={`zone-card-image ${label.startsWith('Opp') ? 'opp-flipped' : ''} ${opponentFieldMap[label].position === 'DEF' ? 'opp-rotated' : ''}`}

  draggable={false}
  onContextMenu={(e) => e.preventDefault()}
  onMouseDown={(e) => e.button === 2 && e.preventDefault()}
  onTouchStart={(e) => e.preventDefault()}
  onClick={() => {
    setSelectedCard({
      ...opponentFieldMap[label].card,
      zone: label,
      position: opponentFieldMap[label].position,
      isOpponentCard: true  // ✅ Add this flag
    });
  }}
/>


            {opponentFieldMap[label].overlays?.length > 0 && (
              <div className="zone-count">×{opponentFieldMap[label].overlays.length}</div>
            )}
          </div>

        // Your card fallback
        ) : fieldMap[label]?.card ?
        (
             <div className="card-wrapper-zone">
                <img
            onContextMenu={(e) => e.preventDefault()}
            onMouseDown={(e) => e.button === 2 && e.preventDefault()}
            onTouchStart={(e) => e.preventDefault()}
            draggable={false}
                src={
                    fieldMap[label].card.isFaceDown
                    ? require('../assets/images/card-back.jpg')
                    : fieldMap[label].card.card_images[0].image_url
                }
                alt={fieldMap[label].card.name}
                className={`zone-card-image ${fieldMap[label].position === 'DEF' ? 'defense' : ''}`}
                onClick={() => {
                    if (pendingOverlay || (pendingExtraSummon?.xyzMode && (label.includes('My MZ') || label.includes('EXMZ')))) return;

                    if (pendingOverlay) return; // 🚫 prevent opening modal during overlay
                    setSelectedCard({
                    ...fieldMap[label].card,
                    zone: label,
                    position: fieldMap[label].position
                    });
                }}
                  loading="lazy"

                />
                {fieldMap[label].overlays?.length > 0 && (
                <div className="zone-count">×{fieldMap[label].overlays.length}</div>
                )}
            </div>
            //SPAN LABEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEL
         ) : null}   
       

    </div>
  );
};



export default PvpSlot;


